import { MatterLitigation } from "@/components/features/matter/litigation/MatterLitigation";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/litigation",
)({
  component: RouteComponent,
  validateSearch: z.object({
    litigationDateId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { litigationDateId } = Route.useSearch();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  return (
    <MatterLitigation
      matter={matter}
      searchLitigationDateId={litigationDateId}
    />
  );
}
